import React, { useState } from "react";
import GenericButton, { ButtonVariant } from "../../ui-components/Button/GenericButton";
import { ReactComponent as Info } from "../../shared/assets/Icons/circle-info-solid.svg";

const ButtonPlayground = () => {
  const [variant, setVariant] = useState<ButtonVariant>("brand");
  const [size, setSize] = useState<"sm" | "md" | "lg">("md");
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <section id="button" className="mb-10">
      <h2 className="text-2xl font-semibold mb-4">Button</h2>
      <div className="flex items-center mb-4">
        <label className="mr-2 font-medium">Variant:</label>
        <select
          value={variant}
          onChange={(e) => setVariant(e.target.value as ButtonVariant)}
          className="border rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          <option value="brand">Brand</option>
          <option value="secondary">Secondary</option>
          <option value="success">Success</option>
          <option value="warning">Warning</option>
          <option value="danger">Danger</option>
        </select>
      </div>
      <div className="flex items-center mb-4">
        <label className="mr-2 font-medium">Size:</label>
        <select
          value={size}
          onChange={(e) => setSize(e.target.value as "sm" | "md" | "lg")}
          className="border rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          <option value="sm">Small</option>
          <option value="md">Medium</option>
          <option value="lg">Large</option>
        </select>
      </div>
      <div className="flex items-center gap-6 mb-4">
        <label className="flex items-center gap-1 font-medium">
          <input
            type="checkbox"
            checked={disabled}
            onChange={() => setDisabled(!disabled)}
          />
          Disabled
        </label>
        <label className="flex items-center gap-1 font-medium">
          <input
            type="checkbox"
            checked={loading}
            onChange={() => setLoading(!loading)}
          />
          Loading
        </label>
      </div>
      <GenericButton
        label="Test Button"
        variant={variant}
        size={size}
        disabled={disabled}
        loading={loading}
        isIconOnly={false}
        slotRight={<Info />}
      />
    </section>
  );
};

export default ButtonPlayground;
